import Combobox from "@ls/react-combobox-grid";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { calcTypeOptions } from "state/Constants/CalcType";
import { scaleTypeOptions } from "state/Constants/ScaleType";
import { Cell, Grid } from "styled-css-grid";
import { selectBookBasisValuesSelectionOptions } from "state/bookAnalytics/selectors";
import {
  selectAnalyticValuesSelectionOptions,
  selectFetchingAnalyticValues,
} from "state/analytics/selectors";

const BookAnalyticsSelectorComplication = ({ setDefinition, definition }) => {
  const analyticOptions = useSelector(selectAnalyticValuesSelectionOptions);
  const filterAmortBookAnalyticOptions = analyticOptions.filter((option) =>
    option.label.toLowerCase().includes("amort"),
  );
  const fetchingAnalyticValues = useSelector(selectFetchingAnalyticValues);
  const bookBasisOptions = useSelector(selectBookBasisValuesSelectionOptions);

  const [setBookAnalytic, setBasis, setCalcType, setScaleType] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setBookAnalytic(value)),
      (value) => setDefinition(definition.setBasis(value)),
      (value) => setDefinition(definition.setCalcType(value)),
      (value) => setDefinition(definition.setScaleType(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={12} gap="4px">
      <Cell width={6}>
        <Combobox
          options={filterAmortBookAnalyticOptions}
          onChange={setBookAnalytic}
          isLoading={fetchingAnalyticValues}
          value={definition.bookAnalytic}
          label="Book Analytic:"
          variation={0}
          size={"S"}
          gridHeight={175}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          options={scaleTypeOptions.filter((option) =>
            ["contribution", "weighted average"].includes(
              (option.label || "").toLowerCase(),
            ),
          )}
          onChange={setScaleType}
          value={definition.scaleType}
          label="Type:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={120}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          options={bookBasisOptions}
          onChange={setBasis}
          value={definition.basis}
          label="Basis:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={120}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          options={calcTypeOptions.filter(
            (option) => option.value !== "Benchmark",
          )}
          onChange={setCalcType}
          value={definition.calcType}
          label="Calc:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={120}
        />
      </Cell>
    </Grid>
  );
};

BookAnalyticsSelectorComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default BookAnalyticsSelectorComplication;
